import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user);
        window.history.replaceState(null, "", "/");
        const pendingClaim = sessionStorage.getItem("pending_claim");
        if (pendingClaim) navigate(`/c/${pendingClaim}`, { replace: true });
        else navigate("/", { replace: true });
      } catch {
        setError(true);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback">
      <div className="card-brutal p-8 text-center">
        <div className="font-display text-2xl font-bold mb-2">
          {error ? "Sign-in failed" : "Signing you in…"}
        </div>
        <p className="text-sm text-muted-foreground">
          {error ? "Please try again." : "Locking in your session."}
        </p>
      </div>
    </div>
  );
}
